import { render, staticRenderFns } from "./StartupRelatorios.vue?vue&type=template&id=84a5fe3a&scoped=true"
import script from "./StartupRelatorios.vue?vue&type=script&lang=js"
export * from "./StartupRelatorios.vue?vue&type=script&lang=js"
import style0 from "./StartupRelatorios.vue?vue&type=style&index=0&id=84a5fe3a&prod&scoped=true&lang=css"
import style1 from "./StartupRelatorios.vue?vue&type=style&index=1&id=84a5fe3a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84a5fe3a",
  null
  
)

export default component.exports